export const customerPhoneRegExp = /^(\s*)?(\+)?([- ()+]?\d[- ()+]?){10,14}(\s*)?$/;
export const invalidPhoneMsg = 'Enter a correct phone number';
